import { Link } from "react-router-dom";
import { Zap } from "lucide-react";
import { BUSINESS_PHONE, BUSINESS_PHONE_FORMATTED, BRAND } from "@/lib/constants";

export default function Footer() {
    return (
        <footer className="mt-24 border-t border-white/10 bg-[#0A1023]/70" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 grid gap-8 md:grid-cols-4">
                <div>
                    <div className="flex items-center gap-2">
                        <span className="inline-flex items-center justify-center w-9 h-9 rounded-xl bg-emerald-500/20 border border-emerald-500/40">
                            <Zap className="w-5 h-5 text-emerald-300" />
                        </span>
                        <span className="font-extrabold text-white text-lg">{BRAND}</span>
                    </div>
                    <p className="mt-4 text-sm text-slate-400 leading-relaxed">
                        An independent service helping Texans explore electricity plan options for
                        home and business. Keep more money in your pocket.
                    </p>
                </div>
                <div>
                    <h4 className="text-white font-semibold mb-3">Compare</h4>
                    <ul className="space-y-2 text-sm text-slate-400">
                        <li><Link to="/homeowners" className="hover:text-emerald-300">Homeowners</Link></li>
                        <li><Link to="/renters" className="hover:text-emerald-300">Renters</Link></li>
                        <li><Link to="/moving" className="hover:text-emerald-300">Moving soon</Link></li>
                        <li><Link to="/first-time" className="hover:text-emerald-300">First-time customers</Link></li>
                        <li><Link to="/existing" className="hover:text-emerald-300">Existing customers</Link></li>
                        <li><Link to="/business" className="hover:text-emerald-300">Small business</Link></li>
                    </ul>
                </div>
                <div>
                    <h4 className="text-white font-semibold mb-3">Learn</h4>
                    <ul className="space-y-2 text-sm text-slate-400">
                        <li><Link to="/compare-texas" className="hover:text-emerald-300">Texas plans</Link></li>
                        <li><Link to="/compare-houston" className="hover:text-emerald-300">Houston plans</Link></li>
                        <li><Link to="/fixed-rate" className="hover:text-emerald-300">Fixed-rate plans</Link></li>
                        <li><Link to="/privacy" className="hover:text-emerald-300">Privacy policy</Link></li>
                        <li><Link to="/terms" className="hover:text-emerald-300">Terms of use</Link></li>
                    </ul>
                </div>
                <div>
                    <h4 className="text-white font-semibold mb-3">Reach us</h4>
                    <p className="text-sm text-slate-400">Call or text us anytime.</p>
                    <a href={`tel:${BUSINESS_PHONE}`} className="mt-2 inline-block text-emerald-300 font-bold text-lg" data-testid="footer-phone">
                        {BUSINESS_PHONE_FORMATTED}
                    </a>
                    <p className="mt-4 text-xs text-slate-500 leading-relaxed">
                        Independent representative. Plans, rates, fees, terms, eligibility, and
                        availability vary by location and usage. Information is provided for
                        comparison purposes. Availability and pricing should be verified before
                        enrollment.
                    </p>
                </div>
            </div>
            <div className="border-t border-white/10 py-5 text-center text-xs text-slate-500">
                © {new Date().getFullYear()} {BRAND}. All rights reserved.
            </div>
        </footer>
    );
}
